"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _SanitizedHTML = require("../../SanitizedHTML");

var _CloseableTab = _interopRequireDefault(require("../../CloseableTab/CloseableTab"));

var useStyles = (0, _styles.makeStyles)({
  text: {
    wordBreak: 'break-word'
  }
});

var DescriptionTab = function DescriptionTab(_ref) {
  var content = _ref.content,
      tabProps = (0, _objectWithoutProperties2["default"])(_ref, ["content"]);
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_CloseableTab["default"], tabProps, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    mx: 3,
    mb: 3
  }, /*#__PURE__*/_react["default"].createElement(_SanitizedHTML.SanitizedHTML, {
    className: (0, _classnames["default"])('Body-Regular-Left-Static', classes.text),
    html: content
  })));
};

var _default = /*#__PURE__*/(0, _react.memo)(DescriptionTab);

exports["default"] = _default;